module.exports = __webpack_public_path__ + "amcharts/images/xIconH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIconH.png
// module id = 286
// module chunks = 0